//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="80"
    height="70"
    viewBox="0 0 80 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="22.826"
      cy="35.1301"
      r="11.1302"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
    />
    <circle
      cx="57.8685"
      cy="35.1301"
      r="11.1302"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
    />
    <path
      d="M34.2822 35.5684C36.0793 34.2206 41.0212 32.3337 46.4124 35.5684"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
    />
    <line
      x1="9"
      y1="34.1301"
      x2="11.0434"
      y2="34.1301"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
      stroke-linecap="round"
    />
    <line
      x1="69.6514"
      y1="34.1301"
      x2="71.6948"
      y2="34.1301"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
